import React from "react";

const PdfViewer = () => {
  const params = new URLSearchParams(window.location.search);

  const fileUrl = params.get("file");

  console.log("fileUrl", fileUrl);

  // if (!fileUrl) {
  //   return <p>Invalid file</p>;
  // }

  let pdfUrl =
    "https://keventersvouchermaster.s3.ap-south-1.amazonaws.com/dms/1/S208/96cc2ace-b7d6-4b81-b46d-b8c4182d6589_invoice.pdf?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Date=20241213T064038Z&X-Amz-SignedHeaders=host&X-Amz-Expires=300&X-Amz-Credential=AKIAUGE7RLUI3R7MXGJC%2F20241213%2Fap-south-1%2Fs3%2Faws4_request&X-Amz-Signature=c65bc145c8ec5cd289db1f537e1ec7571cb38f9519d0125ce50a7fcac9449a6a";

  return (
    <div className="w-[100vw] h-[100vh]">
      <iframe src={pdfUrl} width="100%" height="600px" title="PDF Viewer" />
    </div>
  );
};

export default PdfViewer;
